'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdVerticalAlignCenter = function MdVerticalAlignCenter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.6 18.4h26.8v3.2h-26.8v-3.2z m20-10l-6.6 6.6-6.6-6.6h5v-6.8h3.2v6.8h5z m-13.2 23.2l6.6-6.6 6.6 6.6h-5v6.8h-3.2v-6.8h-5z' })
        )
    );
};

exports.default = MdVerticalAlignCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/vertical-align-center.js
// module id = 3421
// module chunks = 0